export const validateTransaction = async (urlApi, transactionId) => {
    const payload = { id: transactionId };

    const response = await fetch(`${urlApi}/api/v/t`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Validation failed');
    }
    return await response.json()
};
